import { Component, Input, ViewEncapsulation } from '@angular/core';
import { DescriptionComponent } from '../description/description.component';
import { AwardsComponent } from '../awards/awards.component';
import {
  RendererPressKitComponent,
  UIPressKit,
} from '@nx-massaud/ui/renderer-press-kit';
import { NgIf } from '@angular/common';
import { UIAward } from '../awards/ui-award.model';
import { MediaPressKit, TermAward } from '@madeinlune/massaud-types';

@Component({
  selector: 'msd-det-ui-infos',
  standalone: true,
  imports: [
    DescriptionComponent,
    AwardsComponent,
    RendererPressKitComponent,
    NgIf,
  ],
  template: `
    <msd-det-ui-description
      [description]="description"
    ></msd-det-ui-description>
    <msd-det-ui-awards [awards]="awards"></msd-det-ui-awards>
    <ng-container *ngIf="pressKit">
      <msd-ui-renderer-press-kit
        class="vertical-list"
        [pressKit]="pressKit"
      ></msd-ui-renderer-press-kit>
    </ng-container>
  `,
  styleUrls: ['./infos.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class InfosComponent {
  @Input()
  description: string | undefined;

  @Input()
  pressKit: MediaPressKit | undefined;

  @Input()
  awards: TermAward[] | undefined;
}
